<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">

    @if(!processing()){
      <app-transferperiod-stepper [activeAction]="activeAction"></app-transferperiod-stepper>
        @if(alert){
          <ngb-alert class="mt-5" [type]="alert.type">{{ alert.message }}</ngb-alert>
        }

        @if( pool ){      
          <div class="d-flex justify-content-between mt-3 mb-1">
            @if(poolUser && assembleFormation && calcFormation){      
              @if(calculator.areAllPlacesWithoutTeamReplaced(assembleFormation, poolUser.getTransferPeriodActionList().replacements)) {
                @if(pool){
                  <button class="btn btn-outline-primary"
                    (click)="linkToTransfers(pool)">
                    <span>ga naar transfers</span>
                  </button>
                }
              } @else {
                <button            
                  class="btn btn-secondary ms-1" disabled>
                  {{calcFormation.getName()}}
                </button>
              }
            }
          </div>
        }


        @if(pool && poolUser && calcFormation && assembleFormation) {
          @if(!selectedPlace) {          
            <!-- lines-->
            @for(line of calcFormation.getLines();track line.getNumber()) {
              <app-pool-formationline-replacements [line]="line"
                [replacements]="poolUser.getTransferPeriodActionList().replacements"
                (replace)="linkToReplace(pool,assembleFormation,$event)" (linkToPlayer)="linkToPlayer(pool,$event)"
                (remove)="remove(assembleFormation,$event)">
              </app-pool-formationline-replacements>
            }
          }
        }
      } @else {
        <h2 class="text-center">
          <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
        </h2>
    }
  </div>
</div>
@if(!processing() && pool){
<app-pool-navbar [current]="NavBarTransfers" [pool]="pool" [poolUser]="poolUser"></app-pool-navbar>
}